
    import { defineComponent, PropType } from 'vue'

    export default defineComponent({
        props: {

        },
        components: {

        },
        data() {
            return {
                name: "",

            }
        },
        computed: {

        },
        methods: {
            add() {
                this.name && this.$emit('add', this.name)
                this.name = ''
            },

        },
    })

    